export const MENU = "menu";
export const HEADER = "header";
export const TEXT = "text";
export const FOLDABLE = "foldable-text";
export const TITLE = "title";
export const IMAGE = "image";
export const VIDEO = "video";
export const YOUTUBE = "youtube";